export const AnalysisMonitoringPage = () => {
    return <>AnalysisMonitoringPage</>
}